module.exports = __webpack_public_path__ + "static/media/sound.df6856a2.jpg";